import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { ApiService } from '@core/providers/http';
import { MessageService } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import {
  InstituicaoGestoraService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
} from '../../api/services';
import { DialogService } from 'primeng/dynamicdialog';
import { CadastrarInstituicaoGestoraComponent } from '../cadastrar-instituicao-gestora/cadastrar-instituicao-gestora.component';
import { InstituicaoGestora } from '../../api/models/instituicao-gestora.model';
import { Pagination } from '@app/shared/model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { CardEmpresa03Component } from './card-empresa-03/card-empresa-03.component';
import { FilterItem } from '../../api/models';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Subscription } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-home-instituicoes-gestoras',
  imports: [
    CommonModule,
    RouterModule,
    ToastModule,
    SearchBarComponent,
    FormsModule,
    PaginatorModule,
    PaginatorControlComponent,
    CardEmpresa03Component,
    DataVoidComponent,
    DialogModule,
    Button,
    SelectModule,
    ReactiveFormsModule,
    InputTextModule,
    BackButtonComponent,
  ],
  providers: [
    MessageService,
    ApiService,
    InstituicaoGestoraService,
    DialogService,
    PaisService,
  ],
  templateUrl: './home-instituicoes-gestoras.component.html',
  styleUrl: './home-instituicoes-gestoras.component.scss',
})
export class HomeInstituicoesGestorasComponent implements OnInit {
  pagination: Pagination<any> = new Pagination<any>();
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  router = inject(Router);
  private auth = inject(AuthStore);
  dialogService = inject(DialogService);
  messageService = inject(MessageService);
  instituicaoGestoraService = inject(InstituicaoGestoraService);
  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];

  estados: any[] = [
    { id: 1, designacao: 'Activo' },
    { id: 2, designacao: 'Inactivo' },
  ];

  tipoInstituicao: any[] = [
    { id: 1, designacao: 'Interna' },
    { id: 2, designacao: 'Externa' },
  ];

  isLoading: boolean = false;
  tipoEmpresas: any[] = [];
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  insttuicaoGestoraList: InstituicaoGestora[] = [];
  paginatedInstituicao: InstituicaoGestora[] = [];
  totalRecords: number = 0;
  first: number = 0;
  rows: number = 5;
  empresasCount: any;
  private subscriptions = new Subscription();
  form!: FormGroup;

  constructor(public fb: FormBuilder) {}

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'tipoInstituicao',
      placeholder: 'Tipo de Instituição',
      options: this.tipoInstituicao,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    { type: 'text', controlName: 'nif', placeholder: 'NIF' },
    { type: 'text', controlName: 'nome', placeholder: 'Empresa' },

    {
      type: 'dropdown',
      controlName: 'estado',
      placeholder: 'Estado',
      options: this.estados,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  imagePreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  ngOnInit(): void {
    this.loadCountries();
    this.getAllInstituicoesGestora();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        },
      ),
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        },
      ),
    );

    this.form = this.fb.group({
      nif: [null],
      nome: [null],
      tipoInstituicao: [null],
      estado: [null],
    });
  }

  onFormValueChange(queryParams: any) {
    this.getAllInstituicoesGestora(queryParams);
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  getAllInstituicoesGestora(queryParams?: any) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
      Activo: true,
    };
    this.instituicaoGestoraService.list(params).subscribe(
      (res: any) => {
        this.insttuicaoGestoraList = res.data;
        this.pagination = new Pagination<any>().deserialize(res);
        this.empresasCount = this.pagination?.totalRecords;
        this.isLoading = false; // Parar carregamento

        this.insttuicaoGestoraList.forEach((instGest) => {
          this.getPhotoByInstituicaoGestoraId(instGest.id);
        });
      },
      (error: any) => {
        console.error('Erro ao buscar empresa:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar empresas.',
        });
      },
    );
  }

  loadPhotoByInstituicaoGestoraId(id: number): void {
    this.instituicaoGestoraService.getFotoInstituicaoGestoraById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreviewMap[id] = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da instituição ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllInstituicoesGestora();
  }

  getPhotoByInstituicaoGestoraId(id: number): void {
    this.instituicaoGestoraService.getFotoInstituicaoGestoraById(id).subscribe({
      next: (response: Blob) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreviewMap[id] = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result as string;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da empresa ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  showDialog() {
    if (this.auth.hasAny(['registar_empresa_gestora'])) {
      const ref = this.dialogService.open(
        CadastrarInstituicaoGestoraComponent,
        {
          showHeader: false,
          width: '38%',
          modal: true,
          data: {
            tipoEmpresas: this.tipoEmpresas,
            countries: this.countries,
            provinces: this.provinces,
            municipalities: this.municipalities,
          },
        },
      );

      ref.onClose.subscribe((data) => {
        if (data instanceof FormData) {
          this.isLoading = true; // Iniciar carregamento

          this.instituicaoGestoraService.store(data).subscribe(
            (response: any) => {
              this.getAllInstituicoesGestora();
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Instituição Gestora criada com sucesso!',
                life: 3000,
              });
              this.isLoading = false;
              setTimeout(() => {
                this.router.navigate([`/gestao-bolseiros/empresa-gestora`]);
              }, 2000);
            },
            (error: any) => {
              console.error('Erro ao criar instituição de ensino:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao actualizar instituição de ensino.',
                life: 3000,
              });
              this.isLoading = false;
            },
          );
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  showFilter: boolean = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    console.log('Filtered values:', filters);
    this.getAllInstituicoesGestora(filters);
    this.showFilter = false;
  }
}
